class VwHbsServistanimDTO {
    constructor() {
        this.kota = 100;
    };
    id?: number = 0;
    adi?: string = "";
    aktif?: string = "E";
    aktifBool?: boolean = true;
    fkServistip?: number = null;
    servistipAdi?: string = "";
    kota?: number = null;
    fkHbsBransId?: number = null;
    organizasyonId?: number = null;
    organizasyon?: string = "";
    bransAdi?: string = "";
    ekleyenKullanici?: number = null;
    eklemeTarihi?: string = null;
    guncelleyenKullanici?: number = null;
    guncellemeTarihi?: string = null;
    bagliId?: number = null;
    searchText?: string = "";
    borcVarKabulYok?: string = "E";
    borcVarKabulYokBool?: boolean = true;
    treekey?: string = "";
    aynibransaynigunpolyok?: string = "H";
    aynibransaynigunpolyokBool?: boolean = false;
    protokolGrupId?: number = null;
    email?: string = ""
    taniZorunlu?: string = "H";
    protokolAciklama?: string = "";
    kontrolsuregun?: number = 0;
};
export default VwHbsServistanimDTO;